import React, { Component } from 'react';
import { Tabs, Button, Table, Spin } from 'antd';
import BudgetCommonPanel from '@/components/BudgetCommonPanel';
import {
    getBudgetPrivew,
    getProject,
    getAuxiliaryMaterial,
    getHardMountingMaterials,
    getUpholsteredFurniture,
} from '@/api/personCenter/decorationManage';
import './index.scss';
const { TabPane } = Tabs;

export default class BudgetList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            budgetData: {},
            loading: false,
        };
    }

    getTabTitle = ({ title, count, price }) => {
        return (
            <div className="tab-head-item">
                <span className="tab-head-title">{title}</span>
                <span className="tab-head-detail">
                    <span style={{ marginRight: '1rem' }}>
                        {count + intl.get('decorationDesign.item')}
                    </span>
                    <span style={{ fontWeight: 600 }}>${price}</span>
                </span>
            </div>
        );
    };

    getPriviewPanel = budgetData => {
        const { list } = budgetData?.budgetPrivew || {};
        if (!list) return null;
        let data = list.map((v, index) => {
            return { ...v, key: index + 1 };
        });
        let columns = [
            {
                title: intl.get('budgetCommonPanel.number'),
                dataIndex: 'key',
                key: 'key',
            },
            {
                title: intl.get('budgetCommonPanel.projectName'),
                dataIndex: 'item_name',
                key: 'name',
            },
            {
                title: intl.get('budgetCommonPanel.remark'),
                dataIndex: 'amount',
                key: 'amount',
            },
            {
                title: intl.get('budgetCommonPanel.rate'),
                key: 'rate',
                dataIndex: 'rate',
            },
            {
                title: intl.get('budgetCommonPanel.countPrice'),
                key: 'item_amount',
                dataIndex: 'item_amount',
            },
            {
                title: intl.get('budgetCommonPanel.description'),
                key: 'note',
                dataIndex: 'note',
            },
        ];

        return (
            <Table
                className="budget-privew"
                size="small"
                columns={columns}
                pagination={false}
                dataSource={data}></Table>
        );
    };

    getProjectPanel = budgetData => {
        return (
            <BudgetCommonPanel
                budgetData={budgetData}
                name="project"></BudgetCommonPanel>
        );
    };

    getAuxiliaryMaterialPanel = budgetData => (
        <BudgetCommonPanel
            name="auxiliaryMaterial"
            budgetData={budgetData}></BudgetCommonPanel>
    );

    getHardMountingMaterialsPanel = budgetData => (
        <BudgetCommonPanel
            name="hardMountingMaterials"
            budgetData={budgetData}></BudgetCommonPanel>
    );

    getUpholsteredFurniturePanel = budgetData => (
        <BudgetCommonPanel
            name="upholsteredFurniture"
            budgetData={budgetData}></BudgetCommonPanel>
    );

    initPanel = ({ tabName, budgetData }) => {
        let map = {
            budgetPrivew: this.getPriviewPanel,
            project: this.getProjectPanel,
            auxiliaryMaterial: this.getAuxiliaryMaterialPanel,
            hardMountingMaterials: this.getHardMountingMaterialsPanel,
            upholsteredFurniture: this.getUpholsteredFurniturePanel,
        };

        return map[tabName](budgetData);
    };
    handleTabChange = key => {
        let projectId = this.props.projectId;
        const map = {
            budgetPrivew: () => {},
            project: getProject,
            auxiliaryMaterial: getAuxiliaryMaterial,
            hardMountingMaterials: getHardMountingMaterials,
            upholsteredFurniture: getUpholsteredFurniture,
        };
        if (this.state.budgetData[key]) {
            return;
        }
        this.setState({ loading: true });
        map[key]({ projectVId: projectId, div: 2 })
            .then(({ data, code, msg }) => {
                if (code !== 0) {
                    this.setState({ loading: false });
                    throw msg;
                }
                this.setState(state => ({
                    budgetData: { ...state.budgetData, [key]: data },
                    loading: false,
                }));
            })
            .catch(err => {
                this.setState({ loading: false });
                throw err;
            });
    };
    initBudgetTabContainer = () => {
        let tabItems = [
            'budgetPrivew',
            'project',
            'auxiliaryMaterial',
            'hardMountingMaterials',
            'upholsteredFurniture',
        ];
        let nameMap = {
            budgetPrivew: 'total',
            project: 'item',
            auxiliaryMaterial: 'assist',
            hardMountingMaterials: 'strong',
            upholsteredFurniture: 'furniture',
        };
        let { budgetData } = this.state;

        return (
            <Tabs
                defaultActiveKey="budgetPrivew"
                size="large"
                onChange={this.handleTabChange}>
                {tabItems.map(key => {
                    let count =
                        budgetData?.budgetPrivew?.view?.[
                            `${
                                nameMap[key] === 'total' ? 'all' : nameMap[key]
                            }_num`
                        ] || 0;
                    let tabTitleArgs = {
                        title: intl.get('decorationDesign.' + key),
                        count,
                        price: budgetData?.budgetPrivew?.view?.[nameMap[key]],
                    };

                    let tabPanelArgs = {
                        tabName: key,
                        budgetData,
                    };

                    return (
                        <TabPane key={key} tab={this.getTabTitle(tabTitleArgs)}>
                            {this.initPanel(tabPanelArgs)}
                        </TabPane>
                    );
                })}
            </Tabs>
        );
    };
    componentDidMount() {
        this.setState({ loading: true });
        getBudgetPrivew({ projectVId: this.props.projectId, div: 2 })
            .then(({ data, code, msg }) => {
                if (code !== 0) {
                    this.setState({ loading: false });
                    throw msg;
                }
                this.setState({
                    budgetData: { budgetPrivew: data },
                    loading: false,
                });
            })
            .catch(err => {
                this.setState({ loading: false });
                throw err;
            });
    }
    render() {
        const { total, allList, notList, updateDate } =
            this.state.budgetData?.budgetPrivew?.view || {};
        return (
            <div className="budget-list">
                <div className="summary-row">
                    <Button type="primary">
                        {intl.get('budgetCommonPanel.downloadList')}
                    </Button>
                    <div className="summary-right">
                        <div className="summary-total">
                            <span style={{ opacity: 0.6 }}>
                                {intl.get('budgetCommonPanel.decorateCoast')}
                            </span>
                            <span className="summary-total-count">
                                {'$' + (total || 0)}
                            </span>
                        </div>
                        <div className="summary-detail">
                            <span style={{ marginRight: '1rem' }}>
                                {intl.get('budgetCommonPanel.updateTime', {
                                    updateDate,
                                })}
                            </span>
                            {intl.get('budgetCommonPanel.message1')}
                            <span>{allList}</span>
                            {intl.get('budgetCommonPanel.message2', {
                                notList,
                            })}
                        </div>
                    </div>
                </div>
                <Spin spinning={this.state.loading}>
                    {this.initBudgetTabContainer()}
                </Spin>
            </div>
        );
    }
}
